export enum ToastState {
  success = 'success',
  error = 'error',
  warning = 'warning',
  info = 'information',
}
